import React, { useState, useImperativeHandle, forwardRef } from "react";
import { ClickAwayListener, Popper } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

export const useHeaderPopupStyles = makeStyles((theme) => {
    const styles = {
        paper: {
            border: "none",
            padding: 16,
            backgroundColor: theme.palette.background.paper,
            boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        },
        headerButton: {
            height: "100%",
            border: "none",
            padding: "16px 8px 0px",
            backgroundColor: "unset",
            "&:focus": {
                border: "none",
                backgroundColor: "unset",
                outline: "none",
            },
        },
        headerButtonOpen: {
            height: "100%",
            border: "none",
            padding: "0px",
            backgroundColor: "white",
            borderRadius: "unset",
            "&:focus": {
                border: "none",
                backgroundColor: "white",
                outline: "none",
            },
        },
        linkButton: {
            border: "none",
            color: "var(--blue-bell)",
            backgroundColor: "white",
            paddingTop: "5px",
            display: "block",
            "&:focus": {
                border: "none",
                outline: "none",
            },
            "&:disabled": {
                color: "var(--inactive-color)",
            },
        },
        icon: {
            marginRight: "12px",
            marginLeft: "12px",
        },
    };
    return {
        ...styles,
        headerAdminButtonOpen: { ...styles.headerButtonOpen },
        headerAdminButton: { ...styles.headerButton },
    };
});

export const HeaderPopup = (props, ref) => {
    const classes = useHeaderPopupStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    useImperativeHandle(ref, () => ({
        close: () => {
            setAnchorEl(null);
        },
    }));

    const openPopup = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            {props.isAdmin ? (
                <IconButton
                    className={open ? classes.headerAdminButtonOpen : classes.headerAdminButton}
                    style={{ justifyContent: `${props.customStyle ? "flex-start" : ""}`, background: "none" }}
                    aria-describedby={open ? props.id : undefined}
                    type="button"
                    onClick={openPopup}>
                    {props.icon(open)}
                </IconButton>
            ) : (
                <IconButton
                    className={open ? classes.headerButtonOpen : classes.headerButton}
                    aria-describedby={open ? props.id : undefined}
                    style={{ justifyContent: `${props.customStyle ? "flex-start" : ""}` }}
                    type="button"
                    onClick={openPopup}>
                    {props.icon(open)}
                </IconButton>
            )}
            <Popper
                id={props.id}
                open={open && !props.isRequestToAddFollowup}
                anchorEl={anchorEl}
                placement={props.isAdmin ? "bottom-start" : "bottom-end"}
                style={{ zIndex: 2005 }}>
                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                    <div className={classes.paper}>{props.children}</div>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default forwardRef(HeaderPopup);
